import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Регистрация Service Worker.
// Нужен для PWA-installability в Chrome Android (без SW баннер «Установить»
// и полный standalone-режим могут не активироваться даже при display:standalone
// в manifest). SW у нас no-op (не кеширует, не перехватывает).
//
// В dev SW НЕ регистрируем и активно чистим — иначе на Windows + YandexDisk
// любое касание файла /sw.js триггерит activate → clients.claim() → страница
// неявно перезагружается, экран мерцает.
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch((err) => {
        console.warn('SW registration failed:', err);
      });
    });
  } else {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
  }
}
